import React, { useContext, useEffect } from "react";
import NavBar from "components/tabs/TabsHolder";
import InventoryKbbTab from "./InventoryKbbTab";
import MMRForm from "./MMRForm";
import { MmrContext } from "../../../../../context/MMRContext";
import { Card, Col, Container, Row } from "reactstrap";
import JDPOWER from "../../../../crm/helperFunctions/JDPOWER";
import BLACKBOOK from "../../../../crm/helperFunctions/BLACKBOOK";
import Manheim from "../../../../crm/helperFunctions/Manheim";
import V_Auto from "../../../../crm/helperFunctions/V_Auto";
import KBBValue from "../../../../crm/helperFunctions/KBBValue";

const InventoryValuesTab = ({ inventoryID, vehicleKbbObj, showVinDecoder }) => {
	const tabs = ["KBB", "MMR"];
	//const tabs = ["KBB"];
	const { vehicleMMRValues, setDefaultMMR } = useContext(MmrContext);

	useEffect(() => {
		console.log(vehicleMMRValues);
		if (!vehicleMMRValues) {
			setDefaultMMR();
		}
	}, []);

	const tabComponents = [
		<Container>
			<Row className="justify-content-center">
				<Col md={12} sm={6}>
					{/* className="mb-3 align-items-center" */}
					<InventoryKbbTab
						inventoryID={inventoryID}
						vehicleKbbObj={vehicleKbbObj}
						showVinDecoder={showVinDecoder}
					/>
				</Col>
			</Row>
		</Container>,
		<Container>
			<Row className="justify-content-center">
				<Col md={12} sm={6}>
					<MMRForm />
				</Col>
			</Row>
		</Container>,
	];
	return (
		<div style={{ minHeight: "1000px" }}>
			<div className="col-md-12">
				<NavBar
					navClass="nav-pills-primary justify-content-center nav nav-pills"
					tabs={tabs}
					tabComponents={tabComponents}
				/>
			</div>
			<div
				className="col-md-12 d-flex justify-content-center"
				style={{ gap: "20px" }}
			>
				<Row>
					<Col>
						<BLACKBOOK />
					</Col>
					<Col>
						<V_Auto />
					</Col>
					<Col>
						<KBBValue />
					</Col>
				</Row>
			</div>
			<div
				className="col-md-12 d-flex justify-content-center"
				style={{ gap: "20px" }}
			>
				<Row>
					<Col>
						<Manheim />
					</Col>

					<Col>
						<JDPOWER />
					</Col>
				</Row>
			</div>
		</div>
	);
};
export default InventoryValuesTab;
